import { AppBar, Toolbar } from '@mui/material';
import { useContext } from 'react';
import sizeConfigs from '../../utils/sizeConfigs';
import { AuthContext } from '../../context/Auth/AuthContext';
import React from 'react';
import { colorConfigs } from 'utils/colors';
import { BoxTopbar, TopBarUser } from './Topbar.style';

const Topbar = () => {
  const auth = useContext(AuthContext);

  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${sizeConfigs.sidebar.width})`,
        ml: sizeConfigs.sidebar.width,
        boxShadow: 'unset',
        backgroundColor: colorConfigs.topbar.bg,
        color: colorConfigs.topbar.color,
      }}
    >
      <Toolbar>
        <BoxTopbar>
          <div></div>
          <TopBarUser>Olá, {auth.user?.nome}</TopBarUser>
        </BoxTopbar>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
